// VehicleDetailsModal.jsx
import React from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { FaCircle } from "react-icons/fa";
import { vehicleSpecsImageURL } from "../../store/constants/baseUrl";

const VehicleDetailsModal = ({ isVehicleDetailShow, setisVehicleDetailShow }) => {
    const rawVBO = localStorage.getItem("VBO") || "{}"; // fallback empty object
    const vbo = JSON.parse(rawVBO) || {};
    const vehicle = vbo.vehicle || null;

    if (!vehicle) return null; // safety check

    const BulletPoints = (text, title) => (
        <div className="flex items-start gap-2 mb-2">
            <FaCircle className="text-[8px] text-gray-600 mt-1 flex-shrink-0" />
            <span className="text-sm text-gray-700">{title + text}</span>
        </div>
    );

    return (
        <Modal
            open={isVehicleDetailShow}
            onClose={() => setisVehicleDetailShow(false)}
            closeAfterTransition
            BackdropProps={{
                style: {
                    backgroundColor: "rgba(120, 118, 161, 0.5)", // #7876A1 50%
                    backdropFilter: "blur(8px)",
                    WebkitBackdropFilter: "blur(8px)", // Safari
                },
            }}
        >
            <Box
                sx={{
                    bgcolor: "background.paper",
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    height: 550,
                    display: "flex",
                    flexDirection: "column",
                    borderRadius: 4,
                    boxShadow: 24,
                    outline: "none",
                    overflow: "hidden",
                    width: { xs: "85%", md: 700 }, // responsive width
                    maxWidth: "95%",
                    paddingBottom: 2,
                }}
            >
                {/* Close Button */}
                <button
                    onClick={() => setisVehicleDetailShow(false)}
                    className="absolute top-3 right-3 z-50 p-1 bg-transparent border-0"
                >
                    <img src="/Vision Agent Icons/X Icon/XLightpurple.svg" alt="Close" />
                </button>

                {/* Image Section - 40% height */}
                <div className="h-[40%] w-full flex justify-center items-center overflow-hidden">
                    <img
                        src={vehicle?.pictureUrl ? vehicleSpecsImageURL + vehicle.pictureUrl : "/images/cargovan.png"}
                        alt={vehicle?.title + " image"}
                        className="w-full h-full object-contain"
                        draggable={false}
                    />
                </div>

                {/* Content Section - 60% height */}
                <div
                    className="h-[60%] w-full px-4 py-2 flex flex-col overflow-y-auto hide-scrollbar"
                    style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
                >
                    <div className="flex-1">
                        <div className="text-lg font-semibold mb-2">{vehicle?.title || "Vehicle"} Info:</div>

                        {vehicle && BulletPoints(
                            `${vehicle.length || 0}ft x ${vehicle.width || 0}ft x ${vehicle.height || 0}ft`,
                            "Cargo space (LxWxH):"
                        )}

                        {vehicle?.cargoSpace?.maxLoad && BulletPoints(vehicle.cargoSpace.maxLoad, "Max load (lbs)")}

                        {vehicle?.recommendedUse?.length > 0 && (
                            <>
                                <div className="text-lg font-semibold mb-2 mt-4">Recommended use</div>
                                {vehicle.recommendedUse.map((use, idx) =>
                                    use?.useLine ? BulletPoints(use.useLine, "", idx) : null
                                )}
                            </>
                        )}
                    </div>

                    <div className="text-xs text-gray-500 mt-2">
                        <i>
                            All measurements are approximate. Cargo space varies based on make and
                            model of vehicle. We categorize our vehicles based on industry standard
                            dimensions but these may vary slightly according to the vehicle that gets
                            matched to your order.
                        </i>
                    </div>
                </div>
            </Box>
        </Modal>
    );
};

export default VehicleDetailsModal;
